import React from "react";
import { Link } from "react-router-dom";

const PaymentCancel = () => (
  <div className="min-h-screen bg-stone-950 flex items-center justify-center px-6 pt-16">
    <div className="max-w-md w-full text-center">
      <div className="magazine-number text-9xl mb-6">Ø</div>
      <h1 className="font-serif-display text-4xl text-stone-100 mb-4">
        No pass, no <span className="italic text-orange-600">cook</span>.
      </h1>
      <p className="text-stone-400 mb-10">
        Payment cancelled &mdash; no charge, no drama. Come back when you fancy cooking something fresh.
      </p>
      <Link
        to="/subscribe"
        data-testid="payment-cancel-back"
        className="inline-flex items-center gap-3 border border-orange-800 hover:border-orange-500 text-orange-500 hover:text-orange-400 px-8 py-4 uppercase text-xs tracking-[0.24em] transition-colors"
      >
        Have another look
      </Link>
    </div>
  </div>
);

export default PaymentCancel;
